import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'
import triggerEvent from 'utils/dataLayer'
import Button from 'components/atoms/Button'
import Form from './Form'

class KoinworksForm extends Component {
  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
    this.calculate = this.calculate.bind(this)

    this.state = {
      amount: 0,
      downPayment: 10,
      totalMax: 0,
      totalMin: 0,
      modal: false,
      minAmount: 10000000,
      minGradePercent: 9 / 100,
      maxGradePercent: 15 / 100,
    }
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ successUrl: document.location.href })
  }

  handleChange(e) {
    const newValue = parseInt(e.target.value.replace(/\./g, ''), 10)

    this.setState({ [e.target.name]: newValue }, () => {
      const {
        amount, duration, minAmount, downPayment,
      } = this.state
      const fund = parseFloat(amount)

      if (amount && duration && downPayment && fund >= minAmount) {
        this.calculate()
      } else {
        this.setState({
          totalMax: 0,
          totalMin: 0,
        })
      }
    })
  }

  calculate() {
    const {
      amount,
      downPayment,
      duration,
      minGradePercent,
      maxGradePercent,
    } = this.state

    const downPaymentAmount = (downPayment / 100) * amount
    const fund = amount - downPaymentAmount

    let totalMin = ((fund * (minGradePercent / 12)) + (fund / duration)).toFixed(0)
    let totalMax = ((fund * (maxGradePercent / 12)) + (fund / duration)).toFixed(0)

    totalMin = totalMin > 0 ? totalMin : 0
    totalMax = totalMax > 0 ? totalMax : 0

    this.setState({
      totalMax,
      totalMin,
    })
  }

  render() {
    return (
      <div className="KoinworksBar sm-down-p-y-md md-up-p-y-lg">
        <Container>
          <Row className="is-flex">
            <Col md="6" className="is-flex-center">
              <div className="koinworks-detail">
                <Typography variant="title" component="h2">
                  Yuk Raih Gelar Sarjana Bersama Koin Pintar
                </Typography>
                <p className="koinworks-description text-justify">
                  Sekarang, mengenyam pendidikan di universitas favorit bukan hanya mimpi. Tak perlu khawatir soal dana, dengan KoinPintar, biaya pendidikan kamu akan terasa lebih ringan dan mudah!
                  <br /><br />
                  *Perhitungan dapat berubah tergantung dari hasil analisis tim kredit KoinWorks dengan rentang bunga antara 0.75% - 1.25%
                </p>
                <Button
                  variant="orange"
                  component="a"
                  href="/koinworks"
                  onClick={() => triggerEvent(`ga/${this.props.gaPrefix}/bottombanner-left`)}
                >
                  Selengkapnya
                </Button>
              </div>
            </Col>
            <Col md="6">
              <Form
                onChange={this.handleChange}
                {...this.state}
                {...this.props}
              />
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

KoinworksForm.propTypes = {
  gaPrefix: PropTypes.string,
}

KoinworksForm.defaultProps = {
  gaPrefix: 'campusprofile',
}

export default KoinworksForm
